import { Component, OnInit, ChangeDetectionStrategy, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {NodeFarmtypeUtil} from 'src/app/domainObjects/nodeRunStatus';
import { UserDataService } from '../../services/user-data-service';
import { TimeUtils  } from '../../services/TimeUtils';
import { ConfigService } from 'src/app/services/config/config.service';
import { NodeRunStatus, NodeRunStatusUtil } from 'src/app/domainObjects/nodeRunStatus';

//import { RefineryViewModel } from '../../viewModels/refineryViewModel';
//import { DataRefineryConfig } from '../../domainObjects/dataRefineryConfig';
export interface NodeBoxType {
  id: number;
  nodetype: string;
}
export interface Farmatype {
  id: number;
  nodeboxtypeid: number;
  farmtype: string;
  color: string;
  iconpath: string;
  ingesticonpath: string;
  processoriconpath:string;
  transforms:Transforms;
}
export interface Transforms {
  icon: Icon[];
  parameters: Parameters[];
}
export interface Icon {
  transform: number;
  iconpath: string;
}
export interface Parameters {
  jsonobject: string;
  default: string;
  isfillrules: boolean;
}
interface ReturnResult {
  transformerData: any[]; // Assuming transformerData is an array
  // You can add other properties of ReturnResult here if needed
}

@Component({
    selector: 'app-run-refinery-dialog',
    templateUrl: './run-refinery-dialog.component.html',
    styleUrls: ['./run-refinery-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})


export class RunRefineryeDialogComponent {
  nodeName: string;
  farmTypeColor: string;
  runType: string;
  returnData:  any[] = [] ;
  nodeStatusArray: { id: string, status: string }[] = [];
  nodedata:  any[] = [] ;
  configJson: any;
  successCount: any=0;
  errorCount: any=0;
  notRunCount: any=0;
  totalSeconds  : any=0;
  totalTimeTaken  : any=0;
  totalRefineryRunTime: any="";
  summaryData: any[] = [];
  detailsVisible: boolean = false; // Initialize details visibility
  specificNode: any;
  NodeRunStatus = NodeRunStatus;
  NodeRunStatusUtil = NodeRunStatusUtil;
  nodeboxtype: NodeBoxType[] = [{
    id: 1,
    nodetype: 'Ingest'
  }, {
    id: 2,
    nodetype: 'Processor'
  }, {
    id: 3,
    nodetype: 'Joiner'
  }, {
    id: 4,
    nodetype: 'Converter'
  }, {
    id: 5,
    nodetype: 'Data Writer'
  }
  ];
    //master dtata for Farm Type
    farmtype: Farmatype[] = [{
      id: 1,
      nodeboxtypeid: 1,
      farmtype: 'Subtask',
      color: '#00B050',
      iconpath:'../assets/images/Extractor Icon - Subtask.png',
      ingesticonpath:'../assets/images/Ingest Node Subtask.png',
      processoriconpath:'../assets/images/Processor Node Icon - Subtask.png',
    transforms:{
    icon:[{transform:0,iconpath:'../assets/images/img.png'},
      {transform:1,iconpath:'../assets/images/Extractor Icon - Subtask.png'},
      {transform:2,iconpath:'../assets/images/img.png'},
      {transform:3,iconpath:'../assets/images/img.png'},
      {transform:4,iconpath:'../assets/images/img.png'},
      {transform:5,iconpath:'../assets/images/img.png'},
      {transform:6,iconpath:'../assets/images/img.png'},
      {transform:7,iconpath:'../assets/images/img.png'},
      {transform:8,iconpath:'../assets/images/img.png'},
      {transform:9,iconpath:'../assets/images/img.png'},
      {transform:10,iconpath:'../assets/images/img.png'},
      {transform:11,iconpath:'../assets/images/img.png'}],
    parameters:[{jsonobject:'orderField',default:'subtaskOrder',isfillrules:false},
      {jsonobject:'isOpenField',default:'isOpenSubtask',isfillrules:false},
      {jsonobject:'isCloseField',default:'isCloseSubtask',isfillrules:false},
      {jsonobject:'defSourceField',default:'',isfillrules:true},
      {jsonobject:'defTargetField',default:'',isfillrules:false}
    ]
    }
    }, {
      id: 2,
      nodeboxtypeid: 1,
      farmtype: 'Task',
      color: '#FFC000',
      iconpath:'../assets/images/Extractor Icon - Task.png',
      ingesticonpath:'../assets/images/Ingest Node Task.png',
      processoriconpath:'../assets/images/Processor Node Icon - Task.png',
    transforms:{
    icon:[{transform:0,iconpath:'../assets/images/img.png'},
      {transform:1,iconpath:'../assets/images/Activity Namer Icon Task.png.png'},
      {transform:2,iconpath:'../assets/images/img.png'},
      {transform:3,iconpath:'../assets/images/img.png'},
      {transform:4,iconpath:'../assets/images/img.png'},
      {transform:5,iconpath:'../assets/images/img.png'},
      {transform:6,iconpath:'../assets/images/img.png'},
      {transform:7,iconpath:'../assets/images/img.png'},
      {transform:8,iconpath:'../assets/images/img.png'},
      {transform:9,iconpath:'../assets/images/img.png'},
      {transform:10,iconpath:'../assets/images/img.png'},
      {transform:11,iconpath:'../assets/images/img.png'}],
    parameters:[{jsonobject:'orderField',default:'taskOrder',isfillrules:false},
      {jsonobject:'isOpenField',default:'isOpenTask',isfillrules:false},
      {jsonobject:'isCloseField',default:'isCloseTask',isfillrules:false},
      {jsonobject:'defSourceField',default:'',isfillrules:true},
      {jsonobject:'defTargetField',default:'',isfillrules:false}
    ]
    }
    }, {
      id: 3,
      nodeboxtypeid: 1,
      farmtype: 'Activity',
      color: '#00B0F0',
      iconpath:'../assets/images/Extractor Icon - Activity.png',
      ingesticonpath:'../assets/images/Ingest Node Activity.png',
      processoriconpath:'../assets/images/Processor Node Icon - Activity.png',
    transforms:{
    icon:[{transform:0,iconpath:'../assets/images/img.png'},
      {transform:1,iconpath:'../assets/images/Extractor Icon - Subtask.png'},
      {transform:2,iconpath:'../assets/images/img.png'},
      {transform:3,iconpath:'../assets/images/img.png'},
      {transform:4,iconpath:'../assets/images/img.png'},
      {transform:5,iconpath:'../assets/images/img.png'},
      {transform:6,iconpath:'../assets/images/img.png'},
      {transform:7,iconpath:'../assets/images/img.png'},
      {transform:8,iconpath:'../assets/images/img.png'},
      {transform:9,iconpath:'../assets/images/img.png'},
      {transform:10,iconpath:'../assets/images/img.png'},
      {transform:11,iconpath:'../assets/images/img.png'}],
    parameters:[{jsonobject:'orderField',default:'subtaskOrder',isfillrules:false},
      {jsonobject:'isOpenField',default:'isOpenSubtask',isfillrules:false},
      {jsonobject:'isCloseField',default:'isCloseSubtask',isfillrules:false},
      {jsonobject:'defSourceField',default:'',isfillrules:true},
      {jsonobject:'defTargetField',default:'',isfillrules:false}
    ]
    }
    }, {
      id: 4,
      nodeboxtypeid: 1,
      farmtype: 'Case',
      color: '#FF0000',
      iconpath:'../assets/images/Extractor Icon - Case.png',
      ingesticonpath:'../assets/images/Ingest Node Case.png',
      processoriconpath:'../assets/images/Processor Node Icon - Case.png',
    transforms:{
    icon:[{transform:0,iconpath:'../assets/images/img.png'},
      {transform:1,iconpath:'../assets/images/Extractor Icon - Subtask.png'},
      {transform:2,iconpath:'../assets/images/img.png'},
      {transform:3,iconpath:'../assets/images/img.png'},
      {transform:4,iconpath:'../assets/images/img.png'},
      {transform:5,iconpath:'../assets/images/img.png'},
      {transform:6,iconpath:'../assets/images/img.png'},
      {transform:7,iconpath:'../assets/images/img.png'},
      {transform:8,iconpath:'../assets/images/img.png'},
      {transform:9,iconpath:'../assets/images/img.png'},
      {transform:10,iconpath:'../assets/images/img.png'},
      {transform:11,iconpath:'../assets/images/img.png'}],
    parameters:[{jsonobject:'orderField',default:'subtaskOrder',isfillrules:false},
      {jsonobject:'isOpenField',default:'isOpenSubtask',isfillrules:false},
      {jsonobject:'isCloseField',default:'isCloseSubtask',isfillrules:false},
      {jsonobject:'defSourceField',default:'',isfillrules:true},
      {jsonobject:'defTargetField',default:'',isfillrules:false}
    ]
    }
    }, {
      id: 5,
      nodeboxtypeid: 1,
      farmtype: 'User',
      color: '#0066FF',
      iconpath:'../assets/images/Extractor Icon - User.png',
      ingesticonpath:'../assets/images/Ingest Node User.png',
      processoriconpath:'../assets/images/Processor Node Icon - User.png',
    transforms:{
    icon:[{transform:0,iconpath:'../assets/images/img.png'},
      {transform:1,iconpath:'../assets/images/Extractor Icon - Subtask.png'},
      {transform:2,iconpath:'../assets/images/img.png'},
      {transform:3,iconpath:'../assets/images/img.png'},
      {transform:4,iconpath:'../assets/images/img.png'},
      {transform:5,iconpath:'../assets/images/img.png'},
      {transform:6,iconpath:'../assets/images/img.png'},
      {transform:7,iconpath:'../assets/images/img.png'},
      {transform:8,iconpath:'../assets/images/img.png'},
      {transform:9,iconpath:'../assets/images/img.png'},
      {transform:10,iconpath:'../assets/images/img.png'},
      {transform:11,iconpath:'../assets/images/img.png'}],
    parameters:[{jsonobject:'orderField',default:'subtaskOrder',isfillrules:false},
      {jsonobject:'isOpenField',default:'isOpenSubtask',isfillrules:false},
      {jsonobject:'isCloseField',default:'isCloseSubtask',isfillrules:false},
      {jsonobject:'defSourceField',default:'',isfillrules:true},
      {jsonobject:'defTargetField',default:'',isfillrules:false}
    ]
    }
    }, {
      id: 6,
      nodeboxtypeid: 1,
      farmtype: 'Behavior',
      color: '#00FFCC',
      iconpath:'../assets/images/Extractor Icon - Behavior.png',
      ingesticonpath:'../assets/images/Ingest Node Behavior.png',
      processoriconpath:'../assets/images/Processor Node Icon - Behavior.png',
    transforms:{
    icon:[{transform:0,iconpath:'../assets/images/img.png'},
      {transform:1,iconpath:'../assets/images/Extractor Icon - Subtask.png'},
      {transform:2,iconpath:'../assets/images/img.png'},
      {transform:3,iconpath:'../assets/images/img.png'},
      {transform:4,iconpath:'../assets/images/img.png'},
      {transform:5,iconpath:'../assets/images/img.png'},
      {transform:6,iconpath:'../assets/images/img.png'},
      {transform:7,iconpath:'../assets/images/img.png'},
      {transform:8,iconpath:'../assets/images/img.png'},
      {transform:9,iconpath:'../assets/images/img.png'},
      {transform:10,iconpath:'../assets/images/img.png'},
      {transform:11,iconpath:'../assets/images/img.png'}],
    parameters:[{jsonobject:'orderField',default:'subtaskOrder',isfillrules:false},
      {jsonobject:'isOpenField',default:'isOpenSubtask',isfillrules:false},
      {jsonobject:'isCloseField',default:'isCloseSubtask',isfillrules:false},
      {jsonobject:'defSourceField',default:'',isfillrules:true},
      {jsonobject:'defTargetField',default:'',isfillrules:false}
    ]
    }
    }, {
      id: 7,
      nodeboxtypeid: 1,
      farmtype: 'Master',
      color: '#DDDDDD',
      iconpath:'',
      ingesticonpath:'',
      processoriconpath:'',
    transforms:{
    icon:[{transform:0,iconpath:'../assets/images/img.png'},
      {transform:1,iconpath:'../assets/images/Extractor Icon - Subtask.png'},
      {transform:2,iconpath:'../assets/images/img.png'},
      {transform:3,iconpath:'../assets/images/img.png'},
      {transform:4,iconpath:'../assets/images/img.png'},
      {transform:5,iconpath:'../assets/images/img.png'},
      {transform:6,iconpath:'../assets/images/img.png'},
      {transform:7,iconpath:'../assets/images/img.png'},
      {transform:8,iconpath:'../assets/images/img.png'},
      {transform:9,iconpath:'../assets/images/img.png'},
      {transform:10,iconpath:'../assets/images/img.png'},
      {transform:11,iconpath:'../assets/images/img.png'}],
    parameters:[{jsonobject:'orderField',default:'subtaskOrder',isfillrules:false},
      {jsonobject:'isOpenField',default:'isOpenSubtask',isfillrules:false},
      {jsonobject:'isCloseField',default:'isCloseSubtask',isfillrules:false},
      {jsonobject:'defSourceField',default:'',isfillrules:true},
      {jsonobject:'defTargetField',default:'',isfillrules:false}
    ]
    }
    }
    ];
  

  constructor(
    @Inject(MAT_DIALOG_DATA) private data,
    private configService: ConfigService,
    private userData: UserDataService,
  
    private dialogRef: MatDialogRef<RunRefineryeDialogComponent>) { }

    nodeFarmtypeUtil = NodeFarmtypeUtil;


    async ngOnInit(): Promise<void> {
  try {


    
    this.nodedata = this.data.nodedata ?? ' ';
    //console.log("nodedata prajna==", this.nodedata);
    this.farmTypeColor = this.data.farmTypeColor ?? ' ';
    //console.log("farmTypeColor prajna==", this.farmTypeColor);
    this.nodeName = this.data.nodeName ?? ' ';
    //console.log("nodeName prajna==", this.nodeName);
    this.runType = this.data.runType ?? ' ';
    this.returnData = this.data.runNodeResponse ?? [];
    this.processData();
    

  } catch (error) {
    console.error('Error in ngOnInit:', error);
  }
}
   // Method to get the status by ID
   getStatusById(id: String): string | undefined {
    const node = this.data.nodestatusData.find(item => item.id === id);
    return node ? node.status : undefined;
  }

 
processData(): void {
  this.successCount = 0;
  this.errorCount = 0;
  this.notRunCount = 0;
  this.totalSeconds = 0;
  let TotaltimeData: string[] = []; 
  //console.log("length===="+ this.returnData.length)
  this.returnData.forEach((returnResult, i) => {
   // console.log("print i===="+ i)
    if (this.getNodeDataByIndex(i)) {
      const node = this.getNodeByIndex(i);
      const successTransformers = [];
      let statusflag: string = ""; // Initialize statusflag as a string
      let statusCode: Number = 0; // Initialize statusflag as a string
      let totalTime: string;
      let timeData: string[] = []; 
    
    
      returnResult.transformerData.forEach(row => {
          //successTransformers.push(row.statusCode);
          timeData.push(row.timeTaken)
        
       
      });
 
      
      totalTime = TimeUtils.sumTimeStrings(timeData);
      //console.log('Total Time check data:', totalTime);
      const successObj = {
        id: node.id,
        rcNo: node.data.rcNo,
        order: i + 1,
        label: node.label,
        nodeBoxName: this.GetNodeBoxName(node.data.nodeboxtypeid),
        farmName: this.GetFarmName(node.data.farmtypeid),
        transformers: this.getNodeDataSubtitleSplitByDelimiter(i).length,
        status: statusflag,
        transformersData: successTransformers,
        statusCode: this.getStatusById(node.id), // Assuming success
        timeTaken: totalTime
      };
      
      this.summaryData.push(successObj);
      TotaltimeData.push(totalTime);
      //console.log("total time ====",TotaltimeData);
      this.totalTimeTaken = TimeUtils.sumTimeStrings(TotaltimeData);
    //  this.summaryData.push(errorObj);

    }
   
   
  });
 // console.log("sumarry array==",this.summaryData)
  this.summaryData.forEach(row => {
    // Check if the statusCode is 1, 6, or 8 and increment the corresponding count variable
    if (row.statusCode === 6) {
        this.successCount++;
    } else if (row.statusCode === 8) {
      this.errorCount++;
    } else if (row.statusCode === 1) {
      this.notRunCount++;
    }
});
 
}

  getNodeByIndex(index: number): any {
    return this.nodedata[index];
  }
  getNodeDataByIndex(index: number): any {
    return this.nodedata[index]?.data;
  }

 
  getNodeDataSubtitleSplitByDelimiter(index: number): string[] {
    const node = this.nodedata[index];
    if (node && node.data && node.data.subtitle) {
      return node.data.subtitle.split(' > ');
    }
    return [];
  }


    toggleDetails() {
      this.detailsVisible = !this.detailsVisible; // Toggle the visibility
    }
   
    cancel(): void {
      this.dialogRef.close();
    }
    GetNodeBoxName(nodeboxtypeid: number) {
      var ft = this.nodeboxtype.find(x => x.id == nodeboxtypeid);
      if (!ft) return '';
      return ft.nodetype;
    }
    GetFarmName(farmtypeid: number) {
      var ft = this.farmtype.find(x => x.id == farmtypeid);
      if (!ft) return '';
      return ft.farmtype;
    }
  
}
